<template>
  <div class="ts-rounded">
    <div class="ts-overflow-y-scroll" style="max-height: 30vh">
      <table class="ts-w-full">
        <thead>
          <tr class="ts-bg-gray-200 ts-h-10 ts-sticky ts-top-0">
            <th style="width: 20%" class="ts-pl-2 ts-whitespace-no-wrap">
              {{ $t('productProfile.transactionNumber') }}
            </th>
            <th style="width: 15%" class="ts-whitespace-no-wrap">
              {{ $t('productProfile.transactionType') }}
            </th>
            <th style="width: 15%" class="ts-whitespace-no-wrap ts-text-center">
              {{ $t('productProfile.transactionDate') }}
            </th>
            <th style="width: 20%" class="ts-pl-2 ts-whitespace-no-wrap">
              {{ $t('productProfile.locationName') }}
            </th>
            <th style="width: 20%" class="ts-whitespace-no-wrap">
              {{ $t('productProfile.toLocationName') }}
            </th>

            <th style="width: 10%" class="ts-whitespace-no-wrap ts-text-center">
              {{ $t('productProfile.status') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(value, index) in values"
            :key="index"
            class="ts-cursor-pointer hover:ts-bg-gray-300 ts-w-full ts-h-10"
          >
            <td class="ts-whitespace-no-wrap ts-pl-2">
              {{ value.transaction_number }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ value.transaction_type }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-center">
              {{ transactionDate(value.transaction_date) }}
            </td>
            <td class="ts-whitespace-no-wrap ts-pl-2">
              {{ value.location_name }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ value.to_location_name }}
            </td>

            <td class="ts-text-center">
              <span class="ts-capitalize" :class="statusStyle(value.status)">
                {{ value.status }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: ['values'],
  computed: {
    statusStyle: () => (status) => {
      let badge = ''

      switch (status) {
        case 'Pending':
          badge = 'badge badge-info'
          break
        case 'Confirmed':
          badge = 'badge badge-primary'
          break
      }

      return badge
    },
  },
  methods: {
    transactionDate(date) {
      return moment(date).format('DD-MM-YYYY')
    },
  },
}
</script>
